module.exports = __webpack_public_path__ + "static/media/knec_logo.c164f92c.png";